import React, { useState } from 'react';
import { Star, ChevronLeft, ChevronRight } from 'lucide-react';

// Brand icons — inline SVG per accuratezza colori
const GoogleIcon = ({ className = 'w-4 h-4' }) => (
  <svg className={className} viewBox="0 0 48 48" aria-hidden="true">
    <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"/>
    <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"/>
    <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"/>
    <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"/>
  </svg>
);

const TripAdvisorIcon = ({ className = 'w-4 h-4' }) => (
  <svg className={className} viewBox="0 0 24 24" fill="#00AF87" aria-hidden="true">
    <path d="M12.006 4.295c-2.67 0-5.338.784-7.645 2.353H0l1.963 2.135a5.997 5.997 0 0 0 4.04 10.43 5.976 5.976 0 0 0 4.075-1.6L12 19.705l1.922-2.09a5.972 5.972 0 0 0 4.072 1.598 6 6 0 0 0 6-5.998 5.982 5.982 0 0 0-1.957-4.432L24 6.648h-4.35a13.573 13.573 0 0 0-7.644-2.353zM12 6.255c1.531 0 3.005.286 4.395.85-3.28 1.023-5.735 4.014-5.735 7.494 0 .285.02.565.05.844l-.71.771-.71-.772c.03-.278.05-.558.05-.843 0-3.48-2.455-6.47-5.735-7.494A11.667 11.667 0 0 1 12 6.255zM6.005 8.842a4.06 4.06 0 0 1 4.058 4.061 4.06 4.06 0 0 1-4.058 4.06 4.061 4.061 0 0 1-4.06-4.06 4.061 4.061 0 0 1 4.06-4.061zm11.99 0a4.062 4.062 0 0 1 4.06 4.061 4.062 4.062 0 0 1-4.06 4.06 4.06 4.06 0 0 1-4.055-4.06 4.06 4.06 0 0 1 4.056-4.061zm-11.99 1.902a2.16 2.16 0 0 0-2.158 2.159A2.16 2.16 0 0 0 6.005 15.06a2.16 2.16 0 0 0 2.158-2.158 2.16 2.16 0 0 0-2.158-2.159zm11.99 0a2.16 2.16 0 0 0-2.156 2.159 2.16 2.16 0 0 0 2.156 2.158 2.16 2.16 0 0 0 2.158-2.158 2.16 2.16 0 0 0-2.158-2.159zm-11.99.98a1.18 1.18 0 0 1 1.178 1.179 1.18 1.18 0 0 1-1.178 1.178 1.18 1.18 0 0 1-1.18-1.178 1.18 1.18 0 0 1 1.18-1.18zm11.99 0a1.18 1.18 0 0 1 1.178 1.179 1.18 1.18 0 0 1-1.179 1.178 1.18 1.18 0 0 1-1.178-1.178 1.18 1.18 0 0 1 1.178-1.18z"/>
  </svg>
);

const TestimonialsModern = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const testimonialsPerPage = 3;

  const testimonials = [
    { name: 'Raffaele Ciotola', source: 'google', text: 'Siamo stati da Grano e Sale lunedì sera in quattro e l\'esperienza è stata impeccabile. La gentilezza dello staff è davvero rara, un\'accoglienza "top" che ti fa sentire subito a casa.', rating: 5 },
    { name: 'Antonella G.', source: 'tripadvisor', text: 'Ottima pizza ai grani antichi, molto buono il tortino al pistacchio, i bambini hanno gradito cotoletta con patate fritte e hamburger. Da ritornare!', rating: 5 },
    { name: 'Denise', source: 'google', text: 'Venuti qua per un compleanno e siamo rimasti molto molto soddisfatti. Tutto ottimo, antipasto gigantesco con un sacco di cose belle e sfiziose. Pizza super!', rating: 5 },
    { name: 'Andrea D.', source: 'tripadvisor', text: 'Già conosco da anni il locale, ci ritornerò molto volentieri. La pizza rustica è il top! Disponibilità di tre impasti, location molto carina sia versione invernale sia estiva. Ottimo anche per chi va con prole: c\'è un\'area sicura per i bambini fino ai 10 anni.', rating: 5 },
    { name: 'Emanuela Colasanti', source: 'google', text: 'Locale carinissimo ben strutturato, pizza e cibo fantastici, persone carinissime. Ambiente con angolini di privacy e serenità con gli amici per poter parlare con calma.', rating: 5 },
    { name: 'Cliente Tripadvisor', source: 'tripadvisor', text: 'Accoglienza eccellente, servizio veloce e preciso, preparati per gestire intolleranze alimentari. Torno spesso in questo posto perché mi trovo sempre molto bene. Perfetto!', rating: 5 },
    { name: 'Jessica C.', source: 'google', text: 'Il mio ristorante senza glutine preferito. Estrema attenzione per il senza glutine, gentilezza e cortesia dello staff. Qualità del cibo molto alta con vastissima scelta dal menù.', rating: 5 },
    { name: 'Cliente Tripadvisor', source: 'tripadvisor', text: 'Tutto perfetto! Staff estremamente professionale, prezzi giusti e soprattutto zero tempi di attesa. Da ritornare... sempre!', rating: 5 },
    { name: 'Leonardo Damiano', source: 'google', text: 'Posto caratteristico, il loro particolare è il senza glutine. Cordialità da vendere, simpatia ed efficienza sempre. Grano e sale... se non ci vai non sei stato a Narni!', rating: 5 },
  ];

  const totalPages = Math.ceil(testimonials.length / testimonialsPerPage);

  const nextPage = () => {
    setCurrentIndex((prev) => (prev + 1) % totalPages);
  };

  const prevPage = () => {
    setCurrentIndex((prev) => (prev - 1 + totalPages) % totalPages);
  };

  const getCurrentTestimonials = () => {
    const start = currentIndex * testimonialsPerPage;
    return testimonials.slice(start, start + testimonialsPerPage);
  };

  return (
    <section id="recensioni" className="py-24 bg-gray-50">
      <div className="container mx-auto px-6 lg:px-12">
        <div className="max-w-7xl mx-auto">
          {/* Header */}
          <div className="text-center mb-16">
            <h2 className="text-5xl md:text-6xl font-bold text-gray-900 mb-4" style={{ fontFamily: 'Bebas Neue, sans-serif' }}>
              Dicono di Noi
            </h2>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto">
              Le esperienze dei nostri clienti
            </p>
            <div className="w-24 h-1 bg-[#7f9e60] mx-auto rounded-full mt-6"></div>
          </div>

          {/* Testimonials Grid */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12">
            {getCurrentTestimonials().map((testimonial, index) => (
              <div
                key={index}
                className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow duration-300"
              >
                {/* Stars */}
                <div className="flex mb-4">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <Star key={i} className="text-[#7f9e60] fill-[#7f9e60]" size={20} />
                  ))}
                </div>

                {/* Text */}
                <p className="text-gray-700 leading-relaxed mb-6">
                  "{testimonial.text}"
                </p>

                {/* Author */}
                <div className="pt-4 border-t border-gray-200">
                  <p className="text-gray-900 font-bold">{testimonial.name}</p>
                  <div className="flex items-center gap-1.5 text-sm text-gray-500 mt-0.5">
                    {testimonial.source === 'google' ? (
                      <>
                        <GoogleIcon className="w-3.5 h-3.5" />
                        <span>Recensione da Google</span>
                      </>
                    ) : (
                      <>
                        <TripAdvisorIcon className="w-3.5 h-3.5" />
                        <span>Recensione da Tripadvisor</span>
                      </>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Navigation */}
          <div className="flex items-center justify-center space-x-6">
            <button
              onClick={prevPage}
              className="w-12 h-12 bg-white border-2 border-gray-300 rounded-full flex items-center justify-center text-gray-700 hover:bg-[#7f9e60] hover:text-white hover:border-[#7f9e60] transition-all duration-300"
            >
              <ChevronLeft size={24} />
            </button>

            {/* Page Indicators */}
            <div className="flex space-x-3">
              {[...Array(totalPages)].map((_, index) => (
                <button
                  key={index}
                  onClick={() => setCurrentIndex(index)}
                  className={`transition-all duration-300 rounded-full ${
                    index === currentIndex
                      ? 'w-12 h-3 bg-[#7f9e60]'
                      : 'w-3 h-3 bg-gray-300 hover:bg-gray-400'
                  }`}
                />
              ))}
            </div>

            <button
              onClick={nextPage}
              className="w-12 h-12 bg-white border-2 border-gray-300 rounded-full flex items-center justify-center text-gray-700 hover:bg-[#7f9e60] hover:text-white hover:border-[#7f9e60] transition-all duration-300"
            >
              <ChevronRight size={24} />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsModern;